import React, { FormEvent, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import RegisterOscContext from '../../../context/RegisterContext';
import useApi from '../../../hooks/useApi';
import { SubmitButton } from '../../../Korbantech/components/Buttons/SubmitButton';
import { Cause } from '../../../types/Causes';
import { Osc } from '../../../types/Osc';
import { Target } from '../../../types/Target';
import { DataChecks } from '../OscInputs/DataChecks';
import { GridFields } from '../OscInputs/GridFields';
import { OscInput } from '../OscInputs/OscInput';
import { OscTrueFalseInput } from '../OscInputs/OscTrueFalseInput';
import { SpinnerLoad } from '../../Loading/SpinnerLoad'
import { SuccessAlert } from '../../Alerts/SuccessAlert'



interface HelperCause extends Cause {
    checked?: boolean
}
interface HelperTarget extends Target {
    checked?: boolean
}

export const ActuationAndPublic = ({ oldData, update, isPublic }: Props) => {

    const api = useApi();

    const [causes, setCauses] = useState<HelperCause[]>([])
    const [targets, setTargets] = useState<HelperTarget[]>([])
    const [newData, setNewData] = useState<Osc | undefined>(undefined)
    const [isSuccess, setIsSuccess] = useState<boolean>(false)
    const [load, setLoad] = useState<boolean>(false)

    const { setStep } = useContext(RegisterOscContext)
    const { osc } = useContext(RegisterOscContext)

    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        e.currentTarget.checkValidity()
        setLoad(true)
        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget)
        if (update && osc) {
            setLoad(true)
            data.append('_method', 'PATCH')
            if (isPublic){
                await api.post(`/client/me/service`, data).then(res => {
                    setNewData(res.data);
                    setIsSuccess(true)
                }).catch(console.log)
            }else {
                await api.post(`admin/osc/${osc.id}/service`, data).then(res => {
                    setNewData(res.data);
                    setIsSuccess(true)
                }).catch(console.log)
            }
            setLoad(false)
            return
        }
        if (!osc) return
        await api.post(`/osc/${osc.id}/service`, data).then(res => {
            setStep(4)
        }).catch(console.log)
        setLoad(false)
    }, [api, setStep, osc,update, isPublic])

    const loadCauses = useCallback(async () => {
        await api.get('/causes').then(res => {
            setCauses(res.data)
        }).catch(console.log)
    }, [api])

    const loadTargets = useCallback(async () => {
        await api.get('/targets').then(res => {
            setTargets(res.data)
        }).catch(console.log)
    }, [api])

    const data = useMemo((): Osc | undefined => {

        let data: Osc | undefined = undefined

        if (osc) data = osc

        if (oldData) data = oldData

        if (newData) data = newData

        return data

    }, [oldData, osc, newData])

    useEffect(() => {
        loadCauses()
        loadTargets()
    }, [loadCauses, loadTargets])

    useEffect(()=>{
        if(osc?.performace) setStep(4);
    },[osc,setStep])


    return (
        <>
            {isSuccess && <SuccessAlert message='Alterado' closeAlert={() => setIsSuccess(false)} />}
            {oldData && <div className='font-semibold text-xl mb-2'>Atuação e Público</div>}
            <form onSubmit={handleSubmit} className={`grid gap-x-6 gap-y-2 grid-cols-1 md:grid-cols-1 text-gray-800 ${data && 'border-l-4 border-green-600 pl-4 pr-4 rounded-lg '}`}>

                    <OscTrueFalseInput
                        label="Sua instituição se classifica como de Acolhimento e/ou Longa Permanência?"
                        name={'performace[0][shelter]'}
                        defaultValue={data?.performace?.shelter ? data?.performace.shelter : 0}
                        isCheck={data?.performace?.shelter ? true : false}
                    />

                    <OscTrueFalseInput
                        label="Possui inscrição em Conselhos de Direitos?"
                        needDescription
                        name={'performace[0][rights_councils]'}
                        isCheck={data?.performace?.rights_councils ? true : false}
                        descriptionText={data?.performace?.rights_councils}

                    />

                    <DataChecks unique={true} data={causes} label={"Considerando o estatuto social e as "
                        + "áreas prioritárias de atendimento e "
                        + "desenvolvimento de projetos, qual a "
                        + "principal finalidade da instituição? "
                        + "Selecione apenas uma opção."}
                        name={"primary_cause"}
                        select={data?.primary_cause?.id ? data?.primary_cause?.id : ""}
                    />

                    <DataChecks data={causes} label={"Considerando o estatuto social e as "
                        + "áreas prioritárias de atendimento e "
                        + "desenvolvimento de projetos, quais as "
                        + "finalidades secundárias da instituição?"
                        + " Selecione até 2 opções."}
                        name={"causes[]"}
                        maxValue={2}
                    />

                     <DataChecks data={targets} label={"Qual o principal público atendido? selecione até 3 opções."}
                        name={"targets[]"}
                        maxValue={3}
                    />

                    <GridFields label='Quantidade de beneficiários atendidos de forma direta pela instituição. Por faixa etária:'>
                        <OscInput necessary require name={"performace[0][public_from_0_at_5]"} label="0 a 5 anos" defaultValue={data?.performace?.public_from_0_at_5       ? data.performace.public_from_0_at_5   : "0" } />
                        <OscInput necessary require name={"performace[0][public_from_6_at_11]"} label="6 a 12 anos" defaultValue={data?.performace?.public_from_6_at_11    ? data.performace.public_from_6_at_11  : "0" } />
                        <OscInput necessary require name={"performace[0][public_from_12_at_18]"} label="12 a 18 anos" defaultValue={data?.performace?.public_from_12_at_18 ? data.performace.public_from_12_at_18 : "0" } />
                        <OscInput necessary require name={"performace[0][public_from_19_at_29]"} label="19 a 29 anos" defaultValue={data?.performace?.public_from_19_at_29 ? data.performace.public_from_19_at_29 : "0" } />
                        <OscInput necessary require name={"performace[0][public_from_30_at_59]"} label="30 a 59 anos" defaultValue={data?.performace?.public_from_30_at_59 ? data.performace.public_from_30_at_59 : "0" } />
                        <OscInput necessary require name={"performace[0][public_over_60]"} label="Maior de 60 anos" defaultValue={data?.performace?.public_over_60 ? data.performace.public_over_60               : "0" } />
                    </GridFields>
                    <GridFields label='Em média anual, quantos beneficiários indiretos são impactados pela organização?'>
                        <OscInput necessary name={"performace[0][public_indirect]"} defaultValue={data?.performace?.public_indirect ? data?.performace.public_indirect : "0"} />
                    </GridFields>

                    <div className='flex justify-between mb-3 mt-3'>
                    {load && <SpinnerLoad />}
                    {!load && <>
                    <div>
                         {!update && <button onClick={()=>setStep(2)} className='border border-gray-500 bg-white py-1 px-2 rounded-md'>Anterior</button>}
                    </div>
                    <div>
                        <SubmitButton value={update ? "Atualizar Atuação e Público" : "Proximo"} />
                    </div>
                    </>}
                </div>


            </form>
        </>
    )
}



interface Props {
    update?: boolean
    oldData?: Osc
    isPublic?: boolean
}
